import React, {useState} from 'react'
import arrowDown from '../../assets/arrowDown.svg'
import menuIcon from '../../assets/menuIcon.svg'
import menuXicon from '../../assets/menuXicon.svg'

const Navbar = () => {
    const[click, setClick] = useState(true);
    const[show, setShow] = useState(false);
    const [activeNav, setActiveNav] = useState('#');
    
    const hover = [
        {name:'Cash Point',ref:'#services'},
        {name:'Mortgage Loans',ref:'#services'},
        {name:'Personal Loans',ref:'#services'},
        {name:'Machinery Loans',ref:'#services'},
        {name:'Piggy Bank',ref:'#services'},
        {name:'Home appliance Loan',ref:'#services'}, 
        {name:'Fixed Deposit',ref:'#services'}]
    

  return (
    <section className='md:bg-green'>

            {/* desktop navbar */}
            <nav className='hidden md:inline-flex h-[56px] w-full mx-auto bg-primary fixed top-0 z-50 md:pl-[61px] md:pr-[57px] flex items-center justify-between whitespace-nowrap'>
                        <div className=''>
                           <a href="/"> 
                                <h1 className='w-[221px] h-[24px]  leading-[24px] tracking-[0.005em] text-[16px] text-white text-center'>Kpoikpoimingi ltd</h1>
                           </a>
                        </div>

                        <ul className='flex hidden md:inline-flex items-center mr-[65px] text-white font-bold text-[16px] leading-[24px] tracking-[0.005em]'>
                            <li className='px-[25px]'><a onClick={() => setActiveNav('#')} className={`"hover:text-light transition ease-out duration-500" ${activeNav === "#" ? "underline underline-offset-4 decoration-white decoration-2" : " "} `}href="/">Home</a></li>
                            <li className='px-[25px]'><a onClick={() => setActiveNav('#about')} className={`"hover:text-light transition ease-out duration-500" ${activeNav === "#about" ? "underline underline-offset-4 decoration-white decoration-2  " : " "} `}href="#about">About Us</a></li>
                            <li onClick={() => setShow(!show)}   className={'px-[25px] flex'}><a onClick={() => setActiveNav('#services')} className={`"hover:text-light transition ease-out duration-500" ${activeNav === "#services" ? "underline underline-offset-4 decoration-white decoration-2  " : " "} `}href="#services">Our Services</a> <img className='ml-[8px] hidden md:block' src={arrowDown} alt="/" /></li>
                            <li className='pl-[25px]'><a onClick={() => setActiveNav('#contact')} className={`"hover:text-light transition ease-out duration-500" ${activeNav === "#contact" ? "underline underline-offset-4 decoration-white decoration-2  " : " "} `}href="#contact">Our Contact</a></li>
                        </ul>

                            {/* desktop  drowdown */}
                        <div style={{display:show?'block':'none'}} className={'w-[195px] md:hidden absolute  right-[200px] md:right-[130px] top-[50px] text-[14px] leading-[28px] text-white font-bold '}>
                            <ul className='bg-primary space-y-2 px-[10px] pt-[20px] pb-[20px]'>
                                {hover.map((item, i) => (
                                    <li onClick={()=>setShow(!show)} className='hover:bg-light'><a href={item.ref} key={i}>{item.name}</a></li>
                                ))}
                            </ul>
                        </div>
                        
            </nav>
                
                {/* mobile nav icon */}
            <nav className='flex justify-end md:hidden'>
                <div className='block md:hidden absolute right-[18px] top-[61px]'>
                   <img onClick={() => setClick(false)} className='w-[17px] h-[15px]' src={menuIcon} alt="/" />
                </div>
            </nav>

                {/* mobile nav bar */}
            <nav style={{ height: click ? "0%":"100%", transition:"all ease-in-out .5s"}} className='md:hidden fixed bg-primary overflow-hidden top-0 h-full w-full justify-center items-center z-50'>
                <div className='absolute right-[18px] top-[61px]'>
                   <img onClick={() => setClick(true)} className='w-[17px] h-[15px]' src={menuXicon} alt="/" />
                </div> 
                
                <ul className='w-full h-full flex flex-col items-center justify-center text-center text-white font-bold text-[22px] leading-[24px] tracking-[0.005em]'>
                    <li onClick={()=>setClick(true)}  className='py-6 hover:bg-light w-full'><a href='/'>Home</a></li>
                    <li onClick={()=>setClick(true)} className='py-6 hover:bg-light w-full'><a href='#about'>About Us</a></li>
                    <li onClick={()=>setClick(true)} className='py-6 hover:bg-light justify-center w-full flex'><a href='#about'>Our Services</a><img className=' hidden md:block ml-[8px]' src={arrowDown} alt="/" /></li>
                    <li onClick={()=>setClick(true)} className='py-6 hover:bg-light w-full'><a href='#contact'>Our Contact</a></li>
                </ul>
               
            </nav>
            
    </section>
  )
}

export default Navbar